import { analytics } from 'utils/analytics';

export const onBasketClickCb = () => {
  analytics.sendEvent('GA:click', {
    name: 'basket', // название элемента
    position: 'header', // блок, в котором расположен элемент
  });
};
